import { useNavigate } from 'react-router-dom';

export default function BatchComplete({ result, onStartAnother }) {
  const navigate = useNavigate();
  const released = result?.earnings_released ?? 0;
  const held = result?.earnings_held ?? 0;
  const fullyComplete = result?.fully_complete;

  return (
    <div className="text-center py-10" data-testid="batch-complete">
      <div
        className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-5"
        style={{ background: '#00D26A' }}
      >
        <span className="text-3xl">✓</span>
      </div>
      <h2 className="text-2xl font-extrabold text-white mb-2">
        {fullyComplete ? 'Batch complete!' : 'Partial submission saved'}
      </h2>
      <p className="text-zinc-400 mb-6">
        {fullyComplete
          ? 'Everything has been released to your balance.'
          : 'You completed part of the batch. Held portions are forfeit until you complete a full batch.'}
      </p>

      <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 mb-6 inline-block">
        <p className="text-sm text-zinc-400 mb-1">Earnings released to your balance</p>
        <p className="text-4xl font-black text-[#00D26A] mb-3">£{released.toFixed(2)}</p>
        {held > 0 && (
          <p className="text-xs text-zinc-500">
            £{held.toFixed(2)} held{!fullyComplete ? ' (forfeit on partial)' : ''}
          </p>
        )}
        <p className="text-xs text-zinc-500 mt-2">
          Rows written: {result?.rows_written ?? 0}
        </p>
      </div>

      <div className="flex gap-3 justify-center">
        <button
          onClick={() => navigate('/dashboard')}
          className="px-5 py-2 rounded-full font-bold text-sm border border-zinc-700 text-zinc-300 hover:bg-zinc-800"
          data-testid="batch-to-dashboard-btn"
        >
          Back to Dashboard
        </button>
        <button
          onClick={onStartAnother}
          className="px-5 py-2 rounded-full font-bold text-sm"
          style={{ background: 'linear-gradient(90deg,#00D26A,#FFD700)', color: '#050505' }}
          data-testid="start-another-batch-btn"
        >
          Start another batch
        </button>
      </div>
    </div>
  );
}
